export const wrap = ({ small }) => ({
    display: 'inline-block',
    marginTop: 12,
    marginRight: small ? 8 : 16,
});
